<template>
    <div id="app">
        <Header :nav="nav" :sub_nav="sub_nav" :login_show="login_show" @loginShow="loginShowBtn" @navBtn="getNav" @subNavBtn="getSubNav" />
        <router-view/>
        <Footer />
    </div>
</template>

<script>
    import Header from './components/header'
    import Footer from "./components/footer";
    export default {
        name: 'App',
        components: {Footer, Header},
        data(){
            return {
                nav: 'home',
                sub_nav: '',
                login_show: false
            }
        },
        created: function() {
            var url = this.$route.path;
            url = url.split('/');
            url.splice(0,1);
            this.nav = url[0]
            if(url.length >= 2){
                this.sub_nav = url[1]
            }
        },
        methods: {
            getNav(str){
                this.nav = str;
            },
            getSubNav(str){
                this.sub_nav = str;
            },
            loginShowBtn(str){
                this.login_show = str;
            },
        },
        mounted() {

        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue